import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@core-argos-angular-artifact/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IChangePassword } from '../interfaces/change-password.interface';
import { PasswordPolicy } from '../interfaces/password-policy.interface';
import { IUserApps } from '../interfaces/user-applications.interface';
import { IUser } from '../interfaces/user.interface';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private user: IUser;

  private userApps: IUserApps[];

  private passwordPolicy: PasswordPolicy;

  private readonly urlUserBase: string;
  private readonly urlUserAppsBase: string;
  private readonly urlPasswordBase: string;

  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService
  ) {
    const config = this.configService.getConfig();
    this.urlUserBase = `${config.myAccountUserSvc}/api/user`;
    this.urlUserAppsBase = `${this.urlUserBase}/applications`;
    this.urlPasswordBase = `${config.myAccountUserSvc}/api/password-policies`;
  }

  getUser(): Observable<IUser> {
    if (this.user) {
      return of(this.user);
    } else {
      return this.http.get<IUser>(this.urlUserBase).pipe(
        tap(response => {
          this.user = { ...response };
        })
      );
    }
  }

  unlinkUserApp(clientId: string): Observable<any> {
    return this.http.delete<any>(`${this.urlUserAppsBase}/${clientId}`);
  }

  getUserApps(): Observable<IUserApps[]> {
    if (this.userApps) {
      return of(this.userApps);
    } else {
      return this.http
        .get<IUserApps[]>(`${this.urlUserAppsBase}`)
        .pipe(tap(response => (this.userApps = response)));
    }
  }

  changePassword(body: IChangePassword): Observable<any> {
    return this.http.put<IUser>(`${this.urlUserBase}/changePassword`, body);
  }

  getPasswordPolicy(realm: string): Observable<any> {
    if (this.passwordPolicy) {
      return of(this.passwordPolicy);
    } else {
      return this.http
        .get<PasswordPolicy>(`${this.urlPasswordBase}/${realm}`)
        .pipe(tap(response => (this.passwordPolicy = { ...response })));
    }
  }

  resetUser(): void {
    this.user = null;
  }

  resetUserApps(): void {
    this.userApps = null;
  }

  setPasswordPolicy(data: PasswordPolicy): void {
    this.passwordPolicy = { ...data };
  }

  setUser(data: IUser): void {
    this.user = { ...data };
  }
}
